(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initIng(root){
      if(root.__i) return; root.__i=true;
      var track=root.querySelector('[data-track]'); if(!track) return;
      var cards=Array.prototype.slice.call(track.querySelectorAll('.hhing-card'));
      var dotsWrap=root.querySelector('[data-dots]');
      var arrows=root.querySelector('[data-arrows]');
      var prev=root.querySelector('[data-prev]'), next=root.querySelector('[data-next]');
      var chips=Array.prototype.slice.call(root.querySelectorAll('[data-filters] .hhing-chip'));
      function visible(){ return cards.filter(function(c){ return c.style.display !== 'none'; }); }
      function stepW(){ var v=visible(); var c=v[0]||cards[0]; if(!c) return 340; return c.getBoundingClientRect().width + 22; }
      function perView(){ return Math.max(1, Math.round(track.clientWidth / stepW())); }
      function pageCount(){ return Math.max(1, Math.ceil(visible().length / perView())); }
      var dots=[];
      function buildDots(){ if(!dotsWrap) return; dotsWrap.innerHTML=''; dots=[]; var pc=pageCount(); for(var i=0;i<pc;i++){ (function(i){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Go to page '+(i+1)); b.addEventListener('click',function(){ track.scrollTo({left:Math.round(i*perView()*stepW()),behavior:'smooth'}); }); dotsWrap.appendChild(b); dots.push(b); })(i); } }
      function activePage(){ return Math.round(track.scrollLeft / (perView()*stepW())); }
      function sync(){ var a=activePage(); dots.forEach(function(d,i){ d.classList.toggle('on', i===a); }); }
      function fit(){ var overflow = track.scrollWidth > track.clientWidth + 4; track.classList.toggle('is-centered', !overflow); if(dotsWrap) dotsWrap.style.display = overflow ? 'flex' : 'none'; if(arrows) arrows.style.display = overflow ? 'flex' : 'none'; }
      function applyFilter(cat){ cards.forEach(function(c){ c.style.display = (cat==='all' || c.getAttribute('data-cat')===cat) ? '' : 'none'; }); track.scrollLeft=0; buildDots(); sync(); fit(); }
      chips.forEach(function(ch){ ch.addEventListener('click', function(){ chips.forEach(function(x){ x.classList.remove('on'); }); ch.classList.add('on'); applyFilter(ch.getAttribute('data-cat')); }); });
      buildDots(); sync(); fit();
      track.addEventListener('scroll',function(){ window.requestAnimationFrame(sync); });
      var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(function(){ buildDots(); sync(); fit(); }, 150); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left: perView()*stepW(), behavior:'smooth'}); });
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left: -perView()*stepW(), behavior:'smooth'}); });
      var down=false,sx=0,sl=0;
      track.addEventListener('mousedown',function(e){ down=true; sx=e.pageX; sl=track.scrollLeft; track.style.cursor='grabbing'; });
      window.addEventListener('mouseup',function(){ down=false; track.style.cursor='grab'; });
      track.addEventListener('mousemove',function(e){ if(!down) return; e.preventDefault(); track.scrollLeft=sl-(e.pageX-sx); });
    }
    function init(){ document.querySelectorAll('.hhing').forEach(initIng); }
    if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initRev(root){
      if(root.__r) return; root.__r=true;
      var track=root.querySelector('[data-track]'); if(!track) return;
      var cards=track.querySelectorAll('.hhrev-card');
      var dotsWrap=root.querySelector('[data-dots]');
      var countEl=root.querySelector('[data-count]');
      var arrows=root.querySelector('[data-arrows]');
      var prev=root.querySelector('[data-prev]'), next=root.querySelector('[data-next]');
      function isMobile(){ return window.matchMedia('(max-width:600px)').matches; }
      function stepW(){ var c=track.querySelector('.hhrev-card'); if(!c) return 340; return c.getBoundingClientRect().width + 22; }
      function perView(){ return Math.max(1, Math.round(track.clientWidth / stepW())); }
      function pageCount(){ return Math.max(1, Math.ceil(cards.length / perView())); }
      var dots=[];
      function buildDots(){ if(!dotsWrap) return; dotsWrap.innerHTML=''; dots=[]; var pc=pageCount(); for(var i=0;i<pc;i++){ (function(i){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Go to page '+(i+1)); b.addEventListener('click',function(){ track.scrollTo({left:Math.round(i*perView()*stepW()),behavior:'smooth'}); }); dotsWrap.appendChild(b); dots.push(b); })(i); } }
      function activePage(){ return Math.round(track.scrollLeft / (perView()*stepW())); }
      function sync(){ var a=activePage(); dots.forEach(function(d,i){ d.classList.toggle('on', i===a); }); if(countEl) countEl.textContent=(a+1)+' / '+pageCount(); }
      function fit(){ var overflow = track.scrollWidth > track.clientWidth + 4; track.classList.toggle('is-centered', !overflow); var mob=isMobile(); if(dotsWrap) dotsWrap.style.display=(overflow && !mob)?'flex':'none'; if(countEl) countEl.style.display=(overflow && mob)?'block':'none'; if(arrows) arrows.style.display= overflow ? 'flex' : 'none'; }
      buildDots(); sync(); fit();
      track.addEventListener('scroll',function(){ window.requestAnimationFrame(sync); });
      var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(function(){ buildDots(); sync(); fit(); }, 150); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left: perView()*stepW(), behavior:'smooth'}); });
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left: -perView()*stepW(), behavior:'smooth'}); });
      var down=false,sx=0,sl=0;
      track.addEventListener('mousedown',function(e){ down=true; sx=e.pageX; sl=track.scrollLeft; track.style.cursor='grabbing'; });
      window.addEventListener('mouseup',function(){ down=false; track.style.cursor='grab'; });
      track.addEventListener('mousemove',function(e){ if(!down) return; e.preventDefault(); track.scrollLeft=sl-(e.pageX-sx); });
    }
    function init(){ document.querySelectorAll('.hhrev').forEach(initRev); }
    if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-hhugc]').forEach(function(ugc){
      if(ugc.__w) return; ugc.__w=true;
      var down=false,sx=0,sl=0;
      ugc.addEventListener('mousedown',function(e){down=true;sx=e.pageX;sl=ugc.scrollLeft;ugc.style.cursor='grabbing';});
      window.addEventListener('mouseup',function(){down=false;ugc.style.cursor='grab';});
      ugc.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();ugc.scrollLeft=sl-(e.pageX-sx);});
      var wrap=ugc.closest('.hhugc-wrap');
      var np=wrap&&wrap.querySelector('[data-hhugc-next]'), pv=wrap&&wrap.querySelector('[data-hhugc-prev]');
      if(np)np.addEventListener('click',function(){ugc.scrollBy({left:298,behavior:'smooth'})});
      if(pv)pv.addEventListener('click',function(){ugc.scrollBy({left:-298,behavior:'smooth'})});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-video"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function embed(url){ if(/youtu\.be|youtube\.com/.test(url)){ var id=(url.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{6,})/)||[])[1]; return '<iframe src="https://www.youtube.com/embed/'+id+'?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>'; } if(/vimeo\.com/.test(url)){ var v=(url.match(/vimeo\.com\/(\d+)/)||[])[1]; return '<iframe src="https://player.vimeo.com/video/'+v+'?autoplay=1" allow="autoplay" allowfullscreen></iframe>'; } return '<video src="'+url+'" controls autoplay playsinline></video>'; }
    function lb(){ var el=document.querySelector('.hhvid-lb'); if(el) return el; el=document.createElement('div'); el.className='hhvid-lb'; el.innerHTML='<div class="hhvid-lb-inner"></div><button class="hhvid-lb-close" aria-label="Close">&times;</button>'; document.body.appendChild(el); function close(){ el.classList.remove('on'); el.querySelector('.hhvid-lb-inner').innerHTML=''; } el.addEventListener('click',function(e){ if(e.target===el) close(); }); el.querySelector('.hhvid-lb-close').addEventListener('click',close); return el; }
    function open(url){ var el=lb(); el.querySelector('.hhvid-lb-inner').innerHTML=embed(url); el.classList.add('on'); }
    function initVid(root){ if(root.__v) return; root.__v=true; var track=root.querySelector('[data-track]'); if(!track) return; var step=function(){ var c=track.querySelector('.hhvid-card'); return c? c.getBoundingClientRect().width+20:300; }; var n=root.querySelector('[data-next]'), p=root.querySelector('[data-prev]'); if(n)n.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); }); if(p)p.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); }); root.querySelectorAll('[data-video]').forEach(function(m){ function go(){ open(m.getAttribute('data-video')); } m.addEventListener('click',go); m.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' ') go(); }); }); }
    function init(){ document.querySelectorAll('.hhvid').forEach(initVid); }
    if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
